(function () {
  function getFestiveScrollOffset(nav) {
    const root = document.documentElement;
    const headerHeight =
      parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) ||
      document.querySelector('.section-header')?.offsetHeight ||
      0;
    const navHeight = nav?.offsetHeight || 0;
    return headerHeight + navHeight + 1;
  }

  function initNav(nav) {
    const links = nav.querySelectorAll('[data-collection-festive-nav-link]');
    if (!links.length) return;

    const sections = [];
    links.forEach((link) => {
      const id = link.getAttribute('href')?.replace('#', '');
      if (!id) return;
      const target = document.getElementById(id);
      if (target) sections.push({ id, link, target });
    });

    const setActive = (activeId) => {
      links.forEach((link) => {
        const id = link.getAttribute('href')?.replace('#', '');
        link.classList.toggle('is-active', id === activeId);
      });
    };

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const id = link.getAttribute('href')?.replace('#', '');
        const target = id ? document.getElementById(id) : null;
        if (!target) return;

        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - getFestiveScrollOffset(nav);
        window.scrollTo({ top, behavior: 'smooth' });
        setActive(id);
        history.replaceState(null, '', `#${id}`);
      });
    });

    if (!sections.length) return;

    const resolveActiveSectionId = () => {
      const scrollLine = window.scrollY + getFestiveScrollOffset(nav) + 1;
      let activeId = sections[0].id;

      sections.forEach(({ id, target }) => {
        const sectionTop = target.getBoundingClientRect().top + window.scrollY;
        if (sectionTop <= scrollLine) {
          activeId = id;
        }
      });

      return activeId;
    };

    const syncActiveWithScroll = () => {
      setActive(resolveActiveSectionId());
    };

    let rafId = null;
    const onScroll = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(() => {
        syncActiveWithScroll();
        rafId = null;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', syncActiveWithScroll);

    const header = document.querySelector('.section-header');
    const resizeObserver =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(() => syncActiveWithScroll())
        : null;
    if (resizeObserver) {
      if (header) resizeObserver.observe(header);
      resizeObserver.observe(nav);
    }

    const hash = window.location.hash.replace('#', '');
    if (hash && sections.some(({ id }) => id === hash)) {
      setActive(hash);
    } else {
      syncActiveWithScroll();
    }
  }

  function init(root) {
    root.querySelectorAll('[data-collection-festive-nav]').forEach(initNav);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.collection-festive-one15').forEach(init);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.collection-festive-one15') || event.target;
    if (root?.classList?.contains('collection-festive-one15')) {
      init(root);
    }
  });
})();
